import React, {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import TotalesCuadreTable from './TotalesCuadreTable'

const RestTunel = require('../../libs/rest_tunnel')

class TotalesCuadrePage extends Component {
    constructor() {
      super()

      this.state = {
        cajeros: [],
        registros: [],
        filtroFechaInicio: null,
        filtroFechaFin: null
      }

      this.btnBucarClick = this.btnBucarClick.bind(this)

      this.cmbCajeros = React.createRef()

      this.filtroFechaInicio = ""
      this.filtroFechaFin = ""
    }

    btnBucarClick() {
      this.queryTotales()
    }

    fechaFiltroChanged(origen, date) {
      var formatoFechaInicio = "yyyy-LL-dd 00:00:00"
      var formatoFechaFin = "yyyy-LL-dd 23:59:59"
  
      switch (origen) {
        case 'inicio':
          this.setState({
            filtroFechaInicio: date
          })
          this.filtroFechaInicio = date.toFormat(formatoFechaInicio)
          break;
        case 'fin':
          this.setState({
            filtroFechaFin: date
          })
          this.filtroFechaFin = date.toFormat(formatoFechaFin)
          break;
        default:
  
      }
    }


    queryCajeros() {
      console.log('Consultando cajeros....')
      RestTunel.makePetition({
        method: 'POST',
        headers: 'JSON',
        body: {},
        url: process.env.REACT_APP_URL_BACKEND + '/cajeros/list'
      }, (err, data) => {
        if(err) {
          console.log('Error respuesta cajeros')
          this.setState({ mensajeError: data && data.message })
        } else {
          this.setState({ cajeros: data })
        }
      })
    }


    queryTotales() {
        console.log('Consultando totales....')

        var filtroIdCajero = 0

        if(this.cmbCajeros.current && this.cmbCajeros.current.value > 0){
          filtroIdCajero = this.cmbCajeros.current.value
        }

        RestTunel.makePetition({
          method: 'POST',
          headers: 'JSON',
          body: {
            filtro_id_cajero: filtroIdCajero,
            filtro_fecha_inicio: this.filtroFechaInicio,
            filtro_fecha_fin: this.filtroFechaFin
          },
          url: process.env.REACT_APP_URL_BACKEND + '/reportes/totalescuadre/'
        }, (err, data) => {
          if(err) {
            console.log('Error respuesta totales')
            this.setState({ registros: [], mensajeError: data && data.message })
          } else {
            this.setState({ registros: data })
          }
        })
    }

    componentDidMount() {
      this.queryCajeros()
      this.queryTotales()
    }

    render() {
        return(
            <Box>
              <h3>Totales Cuadre</h3>
              <Card>
                <CardContent>
                  <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                    <Grid container xs={10} spacing={2}>
                      <Grid item fullWidth>
                        <Typography gutterBottom variant="h6" component="div">
                          Filtrar totales:
                        </Typography>
                      </Grid>
                      <Grid item container fullWidth>
                        <Grid item xs={2}>
                          <LocalizationProvider dateAdapter={AdapterLuxon}>
                            <DatePicker
                                inputFormat="dd/MM/yyyy"
                              label="Fecha inicio:"
                              value={this.state.filtroFechaInicio}
                              onChange={date => this.fechaFiltroChanged('inicio', date)}
                              renderInput={(params) => <TextField {...params} />}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={2}>
                          <LocalizationProvider dateAdapter={AdapterLuxon}>
                            <DatePicker
                                inputFormat="dd/MM/yyyy"
                              label="Fecha fin:"
                              value={this.state.filtroFechaFin}
                              onChange={date => this.fechaFiltroChanged('fin', date)}
                              renderInput={(params) => <TextField {...params} />}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel>Cajero</InputLabel>
                            <Select
                              inputRef={this.cmbCajeros}
                              defaultValue={0}>
                              <MenuItem value={0}>-- Todos los cajeros --</MenuItem>
                              {this.state.cajeros.map(cajero => (
                                <MenuItem value={cajero.id}>{cajero.alias}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
                <CardActions>
                  <Button variant="contained" onClick={this.btnBucarClick}>Buscar</Button>
                </CardActions>
              </Card>
              <br />
              <TotalesCuadreTable registros={this.state.registros}/>
            </Box>
        )
    }

}

export default TotalesCuadrePage